export type MaintenanceSnapshot = {
  enabled: boolean
  title: string
  message: string
  scheduledStartAt: string | null
  scheduledEndAt: string | null
  updatedAt?: string | null
  updatedByEmail?: string | null
  type?: string
}

export const IDLE_MAINTENANCE: MaintenanceSnapshot = {
  enabled: false,
  title: "",
  message: "",
  scheduledStartAt: null,
  scheduledEndAt: null
}
